import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, cloneDeep } from "lodash";
import ToastModal from "../../../../components/ToastModal";
import Table from '../../../../components/CustomTable';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';
import { Modal } from "semantic-ui-react";
import {
    getDataConfigValuesListAction,
    getDataConfigListAction
} from "../../../../actions";
import { withRouter } from 'react-router-dom';
import { attributeOptions } from './constant';

const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));
const Card = asyncRoute(() => import('../../../../components/Card'));
const Tabs = asyncRoute(() => import('../../../../components/Tabs'));

const List = (props) => {
    const [platformData, setPlatformData] = useState([]);
    const [variableListAllData, setVariableListAllData] = useState([]);
    const [toastModal, setToastModal] = useState({
        enableToast: false,
        toastStatus: "",
        toastMsg: ""
    });
    const [options, setOptions] = useState({
        columns: [
            { id: 1, name: 'id', label: 'S.No.', sortable: false, type: 'number', expand: true, },
            { id: 2, name: 'name', label: 'Attribute Name', sortable: true, type: 'string' },
            {
                id: 3, name: 'platformId', label: 'Platform', sortable: true, type: 'number', component: (row) => {
                    let platform = row.platformData.find(item => item.key == row.platformId);
                    return (
                        <div>
                            {platform ? platform.value : ''}
                        </div>
                    )
                }
            },
            {
                id: 4, name: 'list', label: 'Primary Values', sortable: true, type: 'number', component: (row) => {
                    let rowData = row.list.length > 4 ? row.list.slice(0, 3) : row.list;
                    return (
                        <div>
                            {
                                row.list.length > 4 ?
                                    <>
                                        {
                                            rowData.map(variable => {
                                                return (
                                                    <p>{variable.name}</p>
                                                )
                                            })
                                        }
                                        <a href='javascript:void(0)' className='text-primary' onClick={() => handleExpanded(row)}>
                                            More...
                                            <i class="mdi mdi-menu-down"></i>
                                        </a>

                                    </>
                                    :
                                    rowData.map(variable => {
                                        return (
                                            <p>{variable.name}</p>
                                        )
                                    })
                            }
                        </div>
                    )
                }
            },
            // { id: 3, name: 'platformId', label: 'Platform', sortable: true, type: 'string',  component: (row) =>
            //   (<div></div>)
            // }
            // { id: 4, name: 'secondarlisytyValue', label: 'Secondary Value', sortable: true, type: 'string',
            // component: (row) =>
            // (<div> {row.primaryVarList && row.primaryVarList.length ? row.primaryVarList.map((a, i) => <div key={i}>{
            //   a.secondaryVarList && a.secondaryVarList.length ? a.secondaryVarList.map((sec, ind)=> <div key={ind}>{sec.secondaryVarValue}</div>) :''
            // }</div>) : ''}</div>) },
        ],
        // keyCol: 'ioNo',
        actions: [{
            type: 'edit',
            text: '',
            icon: 'mdi mdi-pencil',
            tooltip: 'Edit'
        },
        ],
        // recActive: true,
        // status: {
        //   key: 'rec_active',
        //   active: '1',
        //   activeIcon: 'mdi mdi-checkbox-marked',
        //   inActiveIcon: 'mdi mdi-close-box',
        //   confirmation: true,
        //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
        //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
        // },
        actionsThead: true,
        sortable: true,
        dateType: true,
        defaultSortParams: {
            // sortBy: 'date',
            // sortOrder: 'asc'
        },
        paging: true,
        defaultPagingParams: {
            pageSize: 25
        }
    });

    const [attributeListModal, setAttributeListModal] = useState(false);
    const [attributeList, setAttributeList] = useState([]);
    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
    const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
    const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
    const dispatch = useDispatch();

    const initializeList = async () => {
        await getPlatformList();
    };

    const toast = (status, msg, type) => {
        setToastModal({
            enableToast: true,
            toastStatus: status,
            toastMsg: msg
        });
        return;
    }

    const handleToastStatus = async (status) => {
        setToastModal({
            ...toastModal,
            enableToast: status
        });
    };

    const confirmationCallbackModel = (id) => {
        setToastModal({
            ...toastModal,
            enableToast: false
        });

        // if (!id) {
        //     submitForm(id);
        // }

        // if (method === "recActiveStatus") {
        //   handleStatusUpdate();
        // }
    };

    const handleExpanded = (row) => {
        let attributeData = [row];
        setAttributeList(attributeData);
        setAttributeListModal(true);
    };

    const getPlatformList = async () => {
        let params = { list: 'all', type: 'platform' };
        await dispatch(getDataConfigValuesListAction({ tenantId, authToken, userId, params }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {
                    setPlatformData(response);
                } else {
                    console.log("Platform list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const getDataConfigList = async () => {
        let params = { list: 'all' };
        await dispatch(getDataConfigListAction({ tenantId, authToken, userId, params }))
            .then((data) => {
                const {
                    responseCode: { status = "" },
                    response,
                } = data;
                if (status === "Success" && response && response.length > 0) {
                    let modifiedResponse = response.map(item => {
                        return {
                            ...item,
                            platformData: platformData
                        }
                    });
                    setVariableListAllData(modifiedResponse);
                } else {
                    console.log("Data config list not found");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handelAction = (row, action) => {
        const { match, history } = props;
        console.log(row);
        if (action.type == 'edit') {
            history.push(`${match.path}/${routes.dataConfig.variables.editVariables}/${row.id}`)
        }
    }

    useEffect(() => {
        initializeList();
    }, []);

    useEffect(() => {
        if (platformData && Array.isArray(platformData) && platformData.length > 0)
            getDataConfigList();
    }, [platformData])

    return (
        <>
            {
                toastModal.enableToast && <ToastModal
                    enableToast={toastModal.enableToast}
                    status={toastModal.toastStatus}
                    msg={toastModal.toastMsg}
                    // path={routes.containers.admin + '/' + routes.admin.account.name}
                    idProps={props}
                    handleConfirmation={confirmationCallbackModel}
                    handleToastStatus={handleToastStatus}
                    confirmationMsg={toastModal.toastMsg}
                    poc={true}
                    outSideClickEnable={false}
                />
            }

            <Modal open={attributeListModal} size="small" className="modal-center-adj">
                <div className="modal-content" style={{ boxShadow: "unset" }}>
                    <div className="modal-header">
                        <h5
                            className="modal-title"
                            style={{ margin: "0 auto", color: "#040B1B" }}
                        >
                            {attributeList[0] ? attributeList[0].name : ''}
                        </h5>
                        <button
                            type="button"
                            onClick={() => {
                                setAttributeListModal(false);
                            }}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <div className="modal-title modal-colse modal-cross">
                                {/* <span aria-hidden="true">x</span> */}
                                <i class="menu-icon tf-icons ti ti-x"></i>
                            </div>
                        </button>
                    </div>
                    <Modal.Content scrolling>
                        <div className="modal-body form__style">
                            <div className="table-responsive">
                                <Table
                                    options={attributeOptions}
                                    data={attributeList}
                                // handelAction={this.handelAction}
                                />
                            </div>
                        </div>
                    </Modal.Content>
                </div>
            </Modal >

            <div className="main-panel ion">
                <div className="content-wrapper">
                    <BreadCrumb />
                    <div className="row mt-3">
                        <Card >
                            <Tabs container="dataConfig" />
                            <div className="table-responsive">
                                <Table
                                    options={options}
                                    data={variableListAllData}
                                    handelAction={handelAction}
                                />
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    )
};

export default withRouter(List);